import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Every "[New Case] Ready for Review" alert email links to /cases/<id>, but the
 * case detail route is /case/<id>. There is no catch-all route, so those links
 * matched nothing and rendered a blank page with no error. The email template is
 * fixed, but the alerts already sitting in inboxes are not, so keep the old URL
 * shape working instead of stranding them.
 */
const LegacyCaseRedirect: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>();
  return <Navigate to={`/case/${caseId}`} replace />;
};

export default LegacyCaseRedirect;
